import type {
  CameraStatus,
  SimulationStatus,
  SmileSimulationFrameSize,
  SmileSimulationLanguage,
  SmileSimulationPatient,
  SmileSimulationPromptVersion,
  SmileSimulationRecord,
  SmileSimulationStep,
} from "./types";

export type SmileSimulationState = {
  step: SmileSimulationStep;
  auth: {
    email: string;
    emailError: string | null;
    password: string;
    passwordError: string | null;
    submitError: string | null;
    isSubmitting: boolean;
  };
  patientDraft: {
    name: string;
    nameError: string | null;
    chartNumber: string;
    chartNumberError: string | null;
  };
  currentPatientId: string | null;
  patients: SmileSimulationPatient[];
  records: SmileSimulationRecord[];
  history: {
    query: string;
    selectedPatientId: string | null;
    selectedRecordId: string | null;
  };
  camera: {
    status: CameraStatus;
    message: string;
    frameSize: SmileSimulationFrameSize | null;
  };
  capture: {
    image: string | null;
  };
  simulation: {
    status: SimulationStatus;
    message: string;
    resultImage: string | null;
    resultRecordId: string | null;
    progress: number;
  };
  settings: {
    language: SmileSimulationLanguage;
    promptVersion: SmileSimulationPromptVersion;
  };
  comparison: {
    value: number;
    isDragging: boolean;
  };
};

export const initialSmileSimulationState: SmileSimulationState = {
  step: "login",
  auth: {
    email: "",
    emailError: null,
    password: "",
    passwordError: null,
    submitError: null,
    isSubmitting: false,
  },
  patientDraft: {
    name: "",
    nameError: null,
    chartNumber: "",
    chartNumberError: null,
  },
  currentPatientId: null,
  patients: [],
  records: [],
  history: {
    query: "",
    selectedPatientId: null,
    selectedRecordId: null,
  },
  camera: {
    status: "idle",
    message: "",
    frameSize: null,
  },
  capture: {
    image: null,
  },
  simulation: {
    status: "idle",
    message: "",
    resultImage: null,
    resultRecordId: null,
    progress: 0,
  },
  settings: {
    language: "en",
    promptVersion: "vertical-lock",
  },
  comparison: {
    value: 50,
    isDragging: false,
  },
};
